import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const SuggestionsPlaceholder = () => (
  <div className="text-center py-5">
    <FontAwesomeIcon
      icon="far fa-lightbulb"
      size="2x"
      className="text-muted mb-3"
    />
    <p className="text-muted mb-0">Coming Soon in the next update</p>
    <p className="text-muted small">
      AI-generated recommendations based on contact data
    </p>
  </div>
);

export default SuggestionsPlaceholder;
